import {   Box, Typography } from '@mui/material'; 
import React, { Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ColorPalette } from '@/components/color-palette';
import { ColorPicker } from '@/components/color-picker';
import { useTheme,Theme } from '@mui/material/styles';

export interface IColorSetting {
  name: string;
  label: string;
  defaultValue: any;
  palette?: string[];
}

export interface IProps {
  helpText?: string;
  settings: IColorSetting[];
}

const useStyles =  (theme:Theme) => ({
  flexContainer: {
    display: 'flex !important',
    width: '100% !important',
    flexWrap: 'wrap !important',
    paddingBottom: `${theme.spacing(2)} !important`,
  },
  pickerAction: {
    paddingLeft: `${theme.spacing(1)} !important`,
    cursor: 'pointer !important',
  },
});

/**
 * ColorControl is a composition of ColorPicker and ColorPalette
 * implemented with react-hook-form Controller
 *
 * @link https://react-hook-form.com/api/usecontroller/controller
 */
export const ColorControl = ({ helpText, settings }: IProps) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { control } = useFormContext();

  return (
    <Fragment>
      <Box sx={classes.flexContainer}>
        {settings.map(({ name, label, defaultValue, palette }, index) => (
          <Controller
            key={index}
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
              <ColorPalette
                label={label}
                color={value}
                palette={palette}
                setColor={onChange}
              >
                <ColorPicker color={value} setColor={onChange}>
                  {/*({ setAnchor }) => (
                    <Typography
                      variant="body2"
                      color="primary"
                      classes={{ root: classes.pickerAction }}
                      onClick={setAnchor}
                    >
                      Custom
                    </Typography>
                  )*/}
                </ColorPicker>
              </ColorPalette>
            )}
          />
        ))}
      </Box>
      {helpText && <Typography variant="caption">{helpText}</Typography>}
    </Fragment>
  );
};
